import { MESSAGE } from '../config'

export const BROWSE_SEARCH_QUERY_KEY = 'browseSearchQuery'
export const BROWSE_SEARCH_RETURN_PATH_KEY = 'browseSearchReturnPath'
export const BROWSE_SEARCH_RESTORE_KEY = 'restoreBrowseSearchQuery'

/**
 * Reads browse-search origin from router location state (set when opening a search result).
 *
 * @param {object} location
 * @returns {{ query: string, returnPath: string }|null}
 */
export function getBrowseSearchOrigin(location) {
  const state = location && location.state
  const query = state && state[BROWSE_SEARCH_QUERY_KEY]
  const returnPath = state && state[BROWSE_SEARCH_RETURN_PATH_KEY]

  if (!query || !returnPath) {
    return null
  }

  return { query, returnPath }
}

/**
 * Location descriptor for a content link opened from browse search results.
 *
 * @param {string} pathname
 * @param {string} searchQuery
 * @param {string} returnPath
 * @returns {{ pathname: string, state: object }}
 */
export function buildBrowseSearchResultLink(pathname, searchQuery, returnPath) {
  return {
    pathname,
    state: {
      [BROWSE_SEARCH_QUERY_KEY]: searchQuery,
      [BROWSE_SEARCH_RETURN_PATH_KEY]: returnPath,
    },
  }
}

/**
 * Breadcrumb that returns the user to browse search results.
 *
 * @param {{ query: string, returnPath: string }} origin
 * @returns {{ title: string, link: object }}
 */
export function buildSearchResultsBreadcrumb(origin) {
  return {
    title: MESSAGE.SEARCH_RESULTS,
    link: {
      pathname: origin.returnPath,
      state: {
        [BROWSE_SEARCH_RESTORE_KEY]: origin.query,
      },
    },
  }
}

/**
 * Short trail used while viewing content opened from browse search.
 *
 * @param {{ query: string, returnPath: string }} origin
 * @param {string} currentTitle
 * @returns {Array}
 */
export function buildSearchOriginBreadcrumbs(origin, currentTitle) {
  return [buildSearchResultsBreadcrumb(origin), { title: currentTitle, link: '' }]
}

/**
 * Query to re-apply when navigating back via the Search Results breadcrumb.
 *
 * @param {object} location
 * @returns {string|null}
 */
export function getBrowseSearchRestoreQuery(location) {
  const query = location && location.state && location.state[BROWSE_SEARCH_RESTORE_KEY]
  return query || null
}

/**
 * Clears the restore flag from history state after applying it.
 *
 * @param {object} history
 */
export function clearBrowseSearchRestoreState(history) {
  const { location } = history
  const state = location.state
  if (!state || !state[BROWSE_SEARCH_RESTORE_KEY]) {
    return
  }

  const nextState = { ...state }
  delete nextState[BROWSE_SEARCH_RESTORE_KEY]

  history.replace({
    pathname: location.pathname,
    search: location.search,
    hash: location.hash,
    state: Object.keys(nextState).length ? nextState : undefined,
  })
}
